var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeLoading)?_c('div',{attrs:{"id":"loading"}},[_c('PulseLoader',{attrs:{"color":_vm.colorLoading,"size":_vm.sizeLoading}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }